import './breadcrumb-style.scss'

import { Link } from 'gatsby'
import _ from 'lodash'
import React from 'react'

import { ReactComponent as ChevronIcon } from '@/assets/icons/crypto_general_icons_chevron-down_clean.svg'

const Breadcrumb = ({
  i18n,
  category,
  // subcategory,
  t,
  addsOnClassName = '',
}) => {
  const description = _.toLower(_.get(category, 'description'))
  const breakcrumb = [
    {
      link: '/trending',
      name: t('breadcrumb.all-articles'),
      hasChevron: !_.isEmpty(_.get(category, 'description')),
    },
  ]
  if (category) {
    breakcrumb.push({
      link: i18n.language.startsWith('en')
        ? `/${description}`
        : `/${description}/${i18n.language.toLowerCase()}`,
      name: t(`breadcrumb.${description}`),
      hasChevron: false,
    })
  }
  return (
    <div className={`breadcrumb ${addsOnClassName}`}>
      {_.map(breakcrumb, (crumb, idx) => (
        <Link
          key={idx}
          to={crumb.link}
          state={!_.isEmpty(crumb.state) ? crumb.state : null}
        >
          <p>{crumb.name}</p>
          {crumb.hasChevron && <ChevronIcon className="icon-chevron" />}
        </Link>
      ))}
    </div>
  )
}

export default Breadcrumb
